module.exports = __webpack_public_path__ + "assets/btn-open-8183adf7.png";